/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const labResults = sqliteTable('lab_results', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  lab_order_test_id: text('lab_order_test_id'),
  patient_id: text('patient_id'),
  source: text('source'),
  form_instance_id: text('form_instance_id'),
  summary: text('summary'),
  result_ready_at: text('result_ready_at'),
  result_ready_by: text('result_ready_by'),
  published_at: text('published_at'),
  published_by: text('published_by'),
  published_by_name: text('published_by_name'),
  corrects_id: text('corrects_id'),
  correction_reason: text('correction_reason'),
  superseded_at: text('superseded_at'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
